export type ObjectKey = keyof object;

export function isObjectEmpty(obj: object): boolean {
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
}

export const sleep = (delay: number) => new Promise((resolve) => setTimeout(resolve, delay));
